import { render, staticRenderFns } from "./DatepickerV2.vue?vue&type=template&id=00fc56bc&scoped=true"
import script from "./DatepickerV2.vue?vue&type=script&lang=js"
export * from "./DatepickerV2.vue?vue&type=script&lang=js"
import style0 from "./DatepickerV2.vue?vue&type=style&index=0&id=00fc56bc&prod&lang=css"
import style1 from "./DatepickerV2.vue?vue&type=style&index=1&id=00fc56bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fc56bc",
  null
  
)

export default component.exports